








































































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";
import useVaultView from "@/hooks/useVaultView";
import { getPostAllowedFileTypes, isAttachmentFile } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";
import { AttachmentFile, PostAllowedFileType, PostFileData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import VaultModal from "@/components/VaultModal";
import EditPostDropZone from "./components/EditPostDropZone";
import { AddingFilesOptions } from "../../types";
import PostFilePreview from "../PostFilePreview";

export default defineComponent({
  name: "PostFilesArea",
  components: {
    PostFilePreview,
    BaseSpinner,
    VaultModal,
    BaseInputFileWithPreview,
    BaseButton,
    CustomScroll,
    EditPostDropZone,
  },
  props: {
    fileList: { type: Array as PropType<PostFileData[]>, required: true },
    newFilePublicAccess: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    loadingUploadUrls: { type: Boolean, default: false },
    showPublicAccessToggle: { type: Boolean, default: false },
    dragAndDropProhibited: { type: Boolean, default: false },
    maxAllowedFiles: { type: Number, default: -1 },
    fileTypes: { type: Array as PropType<PostAllowedFileType[]> },
    buttonText: { type: String as PropType<TranslateResult>, default: $t("Add files") },
  },
  setup(props, { emit }) {
    const { isVaultAvailable, showPrivateVault: showVault, showVaultOrNative } = useVaultView();
    const isDragAndMoveActive = ref(false);

    const postSubject = {
      subjectId: "0",
      subjectType: VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS,
    };

    const allowedFileTypes = computed(() => (props.fileTypes ? props.fileTypes : getPostAllowedFileTypes()));
    const shouldSetFileLimit = computed(() => props.maxAllowedFiles > -1);
    const isReachFileLimit = computed(() => {
      if (!shouldSetFileLimit.value) return false;
      return props.fileList.length >= props.maxAllowedFiles;
    });
    const allowDragAndDrop = computed(() => !(props.dragAndDropProhibited || isReachFileLimit.value));

    const onNativeAddFileHandler = (files: FileList) => {
      emit("addFiles", files, {
        publicAccess: props.newFilePublicAccess,
        unshift: true,
      });
    };

    const onAddFiles = (files: (AttachmentFile | File)[], options: AddingFilesOptions) => {
      if (files.every(isAttachmentFile)) {
        emit("addFilesFromVault", files, options);
      } else {
        emit("addFiles", files, options);
      }
    };

    return {
      shouldSetFileLimit,
      isReachFileLimit,
      allowDragAndDrop,
      isDragAndMoveActive,
      isVaultAvailable,
      showVault,
      postSubject,
      showVaultOrNative,
      allowedFileTypes,
      onNativeAddFileHandler,
      onAddFiles,
    };
  },
});
